import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-repository-page', {
  mixins: [eventListenerMixin],

  connected() {
    window.scrollTo(0, 0);

    this.nav = document.querySelector('tr-repository-nav');
    if (!this.nav) this.renderNav();
    this.activeHeaderNavItem();
  },

  ready() {
    const extendNav = this.querySelector('tr-repository-extend-nav');
    if (extendNav) extendNav.update();

    const documentToc = this.querySelector('tr-document-toc');
    if (documentToc && !documentToc.empty) {
      const container = this.querySelector('.repository-container');
      container.dataset.offset = true;
    }
  },

  disconnected() {
    this.stopListening();
  },

  renderNav() {
    const tpl = this.querySelector('#tpl-tr-repository-nav');
    document.body.insertAdjacentHTML('afterbegin', tpl.innerHTML);
  },

  activeHeaderNavItem() {
    document.querySelector('.header #nav-repository').classList.add('active');
  },
});
